module.exports = __webpack_public_path__ + "static/media/teardown-arrow.35b2e5f4.png";